import gql from "graphql-tag"
import { UserFragmentDoc } from "@pathwright/graphql-client/src/generated"

export default gql`
  query UserQuery($id: Int!) {
    user(id: $id) {
      ...User
    }
  }
  ${UserFragmentDoc}
`
